import type {
  ActionTypeEnum,
  EnrichedAction,
  SentimentType,
  SignalType,
} from '../../services/recommendations_api'

/**
 * Dispatch an action-click event with the correct signal and action types.
 *
 * Uses optional chaining so callers don’t need to guard against an
 * undefined callback.
 *
 * @param onActionClick - Optional callback invoked with action metadata.
 * @param action - The enriched action that was clicked.
 * @param signalType - Signal type of the section (unreplied_email, inactive_deal).
 */
export function dispatchActionClick(
  onActionClick:
    | ((
        action: EnrichedAction,
        signalType: SignalType,
        actionType: ActionTypeEnum
      ) => void)
    | undefined,
  action: EnrichedAction,
  signalType: SignalType
): void {
  onActionClick?.(action, signalType, action.action_type)
}

/**
 * Dispatch a sentiment-feedback event with signal and action metadata.
 *
 * Passes ``null`` when the user toggles off their current sentiment
 * (clears feedback).
 *
 * @param onSentimentClick - Optional callback invoked with sentiment data.
 * @param action - The enriched action being rated.
 * @param signalType - Signal type of the section.
 * @param sentiment - User sentiment (positive, negative, or null to clear).
 */
export function dispatchSentimentClick(
  onSentimentClick:
    | ((
        action: EnrichedAction,
        signalType: SignalType,
        actionType: ActionTypeEnum,
        sentiment: SentimentType | null
      ) => void)
    | undefined,
  action: EnrichedAction,
  signalType: SignalType,
  sentiment: SentimentType | null
): void {
  onSentimentClick?.(action, signalType, action.action_type, sentiment)
}
